import { render, staticRenderFns } from "./wl-button.vue?vue&type=template&id=6c60b690&scoped=true&lang=pug"
import script from "./wl-button.vue?vue&type=script&lang=js"
export * from "./wl-button.vue?vue&type=script&lang=js"
import style0 from "./wl-button.vue?vue&type=style&index=0&id=6c60b690&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60b690",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c60b690')) {
      api.createRecord('6c60b690', component.options)
    } else {
      api.reload('6c60b690', component.options)
    }
    module.hot.accept("./wl-button.vue?vue&type=template&id=6c60b690&scoped=true&lang=pug", function () {
      api.rerender('6c60b690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-button/wl-button.vue"
export default component.exports